/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamDtoSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  tag: z.string().nullish(),
  icon: z.string().nullish(),
  captainId: z.string().nullish(),
  captainUsername: z.string().nullish(),
  captainDisplayName: z.string().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  isVerified: z.optional(z.boolean()),
  verificationReason: z.string().nullish(),
  verificationUpdatedAt: z.iso.datetime().nullish(),
});
